module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._t("default"), _vm._v(" "), _vm._l((_vm.t_data), function(item) {
    return _c('div', {
      staticClass: "poster"
    }, [(item.imgUrl) ? _c('img', {
      staticClass: "i",
      attrs: {
        "src": item.imgUrl
      }
    }) : _vm._e()])
  })], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-febf34e8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-febf34e8"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/pc/vipPage/components/plugins/poster/index.vue
// module id = 3005
// module chunks = 0